import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import vnTranslation from './locales/vn.json'
import enTranslation from './locales/en.json'

const resources = {
    vn: {
        translation: vnTranslation,
    },
    en: {
        translation: enTranslation,
    },
}

i18n.use(initReactI18next).init({
    resources,
    lng: 'vn', // Default language is Vietnamese
    fallbackLng: 'vn',
    interpolation: {
        escapeValue: false,
    },
})

export default i18n
